import { render, staticRenderFns } from "./sendInquiryDialog.vue?vue&type=template&id=24102cd5&scoped=true"
import script from "./sendInquiryDialog.vue?vue&type=script&lang=js"
export * from "./sendInquiryDialog.vue?vue&type=script&lang=js"
import style0 from "./sendInquiryDialog.vue?vue&type=style&index=0&id=24102cd5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24102cd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24102cd5')) {
      api.createRecord('24102cd5', component.options)
    } else {
      api.reload('24102cd5', component.options)
    }
    module.hot.accept("./sendInquiryDialog.vue?vue&type=template&id=24102cd5&scoped=true", function () {
      api.rerender('24102cd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/sendInquiryDialog.vue"
export default component.exports